module.exports = __webpack_public_path__ + "img/collection-weddingRingsCrown.aa25eab.jpg";